import {
  BrowserCacheLocation,
  Configuration,
  LogLevel,
} from '@azure/msal-browser'

const AzureActiveDirectoryAppClientId =
  process.env.REACT_APP_AZURE_B2C_CLIENT_ID
const RedirectURIAfterAuthentication = process.env.REACT_APP_REDIRECT_URI
const PostLogoutRedirectUri = process.env.REACT_APP_GOVCMS_HOME

export const b2cPolicies = {
  names: {
    signUpSignIn: 'B2C_1_FWO_OSP',
    forgotPassword: 'B2C_1_OSP_PASSWORD_RESET',
    editProfile: 'B2C_1_FWO_EDIT_PROFILE',
  },
  authorities: {
    signUpSignIn: {
      authority: process.env.REACT_APP_AZUREB2C_SIGNUP_SIGNIN_AUTHORITY,
    },
    forgotPassword: {
      authority: process.env.REACT_APP_AZUREB2C_FORGOT_PASSWORD_AUTHORITY,
    },
    editProfile: {
      authority: process.env.REACT_APP_AZUREB2C_EDIT_PROFILE_AUTHORITY,
    },
  },
  authorityDomain: process.env.REACT_APP_AZUREB2C_AUTHORITY_DOMAIN,
}

export const MSAL_CONFIG: Configuration = {
  auth: {
    clientId: AzureActiveDirectoryAppClientId, // This is the ONLY mandatory field; everything else is optional.
    authority: b2cPolicies.authorities.signUpSignIn.authority, // Choose sign-up/sign-in user-flow as your default.
    knownAuthorities: [b2cPolicies.authorityDomain], // You must identify your tenant's domain as a known authority.
    redirectUri: RedirectURIAfterAuthentication, // You must register this URI on Azure Portal/App Registration. Defaults to "window.location.href".
    postLogoutRedirectUri: PostLogoutRedirectUri,
  },
  cache: {
    cacheLocation: BrowserCacheLocation.LocalStorage, // Configures cache location. "sessionStorage" is more secure, but "localStorage" gives you SSO between tabs.
    storeAuthStateInCookie: false, // If you wish to store cache items in cookies as well as browser cache, set this to "true".
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message)
            return
          // case LogLevel.Info:
          //   console.info(message)
          //   return
          // case LogLevel.Verbose:
          //   console.debug(message)
          //   return
          case LogLevel.Warning:
            console.warn(message)
            return
        }
      },
    },
  },
}

export const loginRequest = {
  scopes: [process.env.REACT_APP_AZURE_B2C_LOGIN_REQUEST_SCOPES],
}

/**
 * Add here the endpoints and scopes when obtaining an access token for protected web APIs. For more information, see:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/resources-and-scopes.md
 */
export const protectedResources = {
  apiReferenceData: {
    endpoint: process.env.REACT_APP_API_URL,
    scopes: [process.env.REACT_APP_AZURE_B2C_PROTECTED_RESOURCES_SCOPES], // e.g. api://xxxxxx/access_as_user
  },
}
